module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_blue_de-443c02ad671dbf1ae0b43c4c3884369c.png";